/**
 * Este arquivo centraliza a criação de DropdownItems para o menu de funções (fx),
 */

import React from 'react';
import { DropdownItem } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

export function createFormattedFunctionDropdownItem(messageId, formula, condition = true, values = {}, onClickHandler) {
  if (!condition) return null;
  return (
    <DropdownItem key={formula} onClick={() => onClickHandler(formula)}>
      <span>
        <FormattedMessage id={messageId} values={values} />
      </span>
    </DropdownItem>
  );
}

export function createConditionalFunctionDropdownItem(messageId, formula, condition, values = {}, text = null, onClickHandler) {
  if (!condition) return null;
  return (
    <DropdownItem key={formula} onClick={() => onClickHandler(formula)}>
      <span>
        {text || <FormattedMessage id={messageId} values={values} />}
      </span>
    </DropdownItem>
  );
}

export function createModalFunctionDropdownItem(messageId, modalType, onClickHandler) {
  return (
    <DropdownItem key={modalType} onClick={() => onClickHandler(modalType)}>
      <span><FormattedMessage id={messageId} /></span>
    </DropdownItem>
  );
}

export function createConditionalModalDropdownItem(messageId, onClickHandler) {
  return (
    <DropdownItem key="funcaoCondicional" onClick={() => onClickHandler()}>
      <span><FormattedMessage id={messageId} /></span>
    </DropdownItem>
  );
} 